import { auth } from '@/lib';
import { useNosIdMutation } from '@/hooks/api/base.hooks';
import { api } from '@/portal-api.definition';
import { ActionType, useI18n, useToast } from '@nosinovacao/nosid-mfe-common';

export function useInvalidateSessions() {
  const toast = useToast();
  const { t } = useI18n();
  return useNosIdMutation({
    mutationFn: () => api.put('/api/v1/security/invalidate-sessions', void 0),
    successLogAction: () => ({ ActionType: ActionType.Submit }),
    errorLogAction: () => ({ ActionType: ActionType.Submit }),
    ignoreSnackbarForErrors: ['*'],
    onSuccess: async () => {
      await auth.logout(false);
    },
    onError: () => {
      toast.show('error', t('Common.SnackBar.InvalidateSessions.Error'));
    },
  });
}
